import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/useAuth';
import { usePermissions } from '../auth/usePermissions';
import { useMyVisibility } from './visibilityApi';

/**
 * Роут-гейт экранов метрик Продаж (pek6 Ф6): sales.view — полный доступ;
 * managed-роль (менеджер) — по матрице видимости (screen.otdel /
 * screen.manager ≠ none); иначе fail-closed увод. Бэк режет данные сам —
 * это второй слой (роут не рисуется, закрытого не видно и прямой ссылкой).
 */
export function RequireSalesScreen({ screen, children }: { screen: 'otdel' | 'manager'; children: ReactNode }) {
  const { isLoading: authLoading } = useAuth();
  const { can, roles } = usePermissions();
  const { data: vis, isLoading: visLoading } = useMyVisibility();

  if (authLoading || (!can('sales.view') && visLoading)) {
    return (
      <div style={{ minHeight: '50vh', display: 'grid', placeItems: 'center', color: '#683DFF' }}>
        Загрузка…
      </div>
    );
  }

  if (can('sales.view')) {
    return <>{children}</>;
  }

  const allowed = vis?.managed && (vis.blocks?.[`screen.${screen}`]?.scope ?? 'none') !== 'none';
  if (allowed) {
    return <>{children}</>;
  }

  const fallback = roles.includes('manager')
    ? '/sales/my-day'
    : can('sites.read') ? '/sites' : can('advertising.direct') ? '/advertising/direct' : '/finance/my';

  return <Navigate to={fallback} replace />;
}
